<template>
    <div class="saleoutView">
        <vxe-layout-container vertical>
            <vxe-layout-header>
                <div
                    style="display: flex; justify-content: flex-start; align-items: center;margin:10px">
                    <vxe-button status="primary" icon="vxe-icon-save" @click="handleSave" >保存</vxe-button>
                    <vxe-button status="primary" icon="vxe-icon-print" :options="downBtns" @dropdown-click="dropdownClickEvent">打印单据</vxe-button>

                </div>
                <div>
                    <vxe-form ref="formRef" :data="formData" :rules="formRules" title-align="right" title-width="80px">
                        <!-- 单号 -->
                        <vxe-form-item title="单号" field="zjdh" :span="4">
                            <template #default>
                                <vxe-input v-model="formData.zjdh" placeholder="请输入单号" class="form-input"
                                    :editable="false" />
                            </template>
                        </vxe-form-item>

                        <!-- 日期 -->
                        <vxe-form-item title="日期" field="rq" :span="4">
                            <template #default>
                                <vxe-date-picker v-model="formData.rq" placeholder="请选择日期" format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd" class="form-input" />
                            </template>
                        </vxe-form-item>

                        <!-- 客户名称 -->
                        <vxe-form-item title="客户名称" field="khmc" :span="6">
                            <template #default>
                                <vxe-input v-model="formData.khmc" type="search" placeholder="请输入客户名称" clearable
                                    @search-click="handleShowSearchCustomer" @keyup.enter="handleShowSearchCustomer"
                                    class="form-input" />
                            </template>
                        </vxe-form-item>

                        <vxe-form-item field="lxdh" title="联系电话" :span="5">
                            <vxe-input v-model="formData.lxdh" placeholder="请输入联系电话" />
                        </vxe-form-item>

                        <!-- 备注 -->
                        <vxe-form-item title="备注" field="bz" :span="19">
                            <template #default>
                                <vxe-input v-model="formData.bz" placeholder="请输入备注信息" clearable class="form-input" />
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
            </vxe-layout-header>

            <vxe-layout-body>

                <vxe-table border show-footer ref="tableref" height="100%" :data="tableData" :footer-data="footerData" 
                :menu-config="menuConfig" @menu-click="menuClickEvent"
                    @current-change="handleCurrentChange" :edit-config="{ trigger: 'click', mode: 'row' }"
                    :cell-config="{ height: 30 }">
                    <vxe-column field="seq" type="seq" width="70"></vxe-column>
                     <vxe-column field="lx" title="类型" width="120"></vxe-column>
                    <vxe-column field="mc" title="名称" :edit-render="{ name: 'input' }" width="300">
                        <template #edit="{ row, rowIndex }">
                            <vxe-input v-model="row.mc" type="search"
                                @search-click="ShowselectProductDialog(row, rowIndex)"
                                @keydown.enter="ShowselectProductDialog(row, rowIndex)"></vxe-input>
                        </template>
                    </vxe-column>
                    
                    <vxe-column field="dw" title="单位" width="70" :edit-render="{ name: 'input' }"></vxe-column>
                    <vxe-column field="sl" title="数量" show-overflow width="70" :edit-render="{ name: 'input' }">
                        <template #edit="{ row }">
                            <vxe-input v-model="row.sl" @change="updateRow(row)"></vxe-input>
                        </template>
                    </vxe-column>
                    <vxe-column field="dj" title="单价" show-overflow width="100" :edit-render="{ name: 'input' }">
                        <template #edit="{ row }">
                            <vxe-input v-model="row.dj" @input="updateRow(row)"></vxe-input>
                        </template>
                    </vxe-column>
                    <vxe-column field="hj" title="小计" show-overflow width="80">
                        <template #default="{ row }">
                            <span>￥{{ sumPCBuildRowNum(row) }}</span>
                        </template>
                    </vxe-column>
                   <vxe-column field="bz" title="备注" show-overflow :edit-render="{ name: 'input' }"></vxe-column>
                    <vxe-column field="chengbenjia" title="成本价" width="100" :visible="isShowChengben" :edit-render="{ name: 'input' }">
                        <template #edit="{ row }">
                            <vxe-input v-model="row.chengbenjia" @change="updateRow(row)"></vxe-input>
                        </template>
                    </vxe-column>
                    <vxe-column field="chengbenHeji" title="成本合计" width="80" :visible="isShowChengben">
                        <template #default="{ row }">
                            <span>￥{{ sumPCBuildChengBenRowNum(row) }}</span>
                        </template>
                    </vxe-column>
                </vxe-table>

            </vxe-layout-body>
        </vxe-layout-container>
        <!-- 选择商品* -->
        <vxe-modal v-model="showSelectproduct" width="60vw" height="60vh" destroy-on-close title="选择商品">
            <template #default>
                <selectProduct @select="handleSelectProduct" @cancel="showSelectproduct = false"
                    :MnemonicPhraseProp="MnemonicPhrase">
                </selectProduct>
            </template>
        </vxe-modal>
        <!-- 选择客户* -->
        <vxe-modal v-model="showSelectCustomer" width="60vw" height="60vh" destroy-on-close title="客户选择">
            <template #default>
                <selectCustomer @select="handleSelectCustomer" @cancel="showSelectCustomer = false"
                    :MnemonicPhraseProp="formData.khmc">
">
                </selectCustomer>
            </template>
        </vxe-modal>
    </div>
</template>
<script setup>
import { reactive, defineProps, ref, onMounted } from 'vue'
import {  sumNum,sumPCBuildRowNum, sumPCBuildChengBenRowNum } from '@/utils/calculate.js'
import selectProduct from '@/components/selectComp/selectproductComp.vue'
import selectCustomer from '@/components/selectComp/selectCustomerComp.vue'
import { CreateNewDocument, } from '@/utils/saleDocHelper'
import request from '@/request/request'
import  showMessage  from '@/utils/showmessage.js'
import axios from 'axios'
const showSelectproduct = ref(false)
const showSelectCustomer = ref(false)
const tableref = ref(null)
const rowindex = ref(0)
const usefule = ref('')
const isShowChengben = ref(false)
const menuConfig = reactive({
  header: {
    options: [
      [
        { code: 'myBtn1', name: '显示成本价' },
        { code: 'myBtn2', name: '隐藏成本价' }
      ]
    ]
  }
})
const downBtns = ref([
  { name: '1', content: '打印编辑' },
  { name: '2', content: '打印预览' },
  { name: '3', content: '直接打印' }
])
const dropdownClickEvent = (params) => {
  handlePrint(params.option.content)
}
// 搜索客户（打开弹窗并传递关键词）
const handleShowSearchCustomer = () => {
    // 如果有输入内容，可以将其作为搜索关键词传递给弹窗
    // 这里通过修改弹窗的 props 或触发事件来实现
    showSelectCustomer.value = true
}

const handleCurrentChange = (row, index) => {
    rowindex.value = index
}
// 在值发生改变时更新表尾合计
// 更新某一行的小计，再刷新底部合计
const updateRow = (row) => {
  row.hj = (Number(row.sl) * Number(row.dj)).toFixed(2)
  // 如果你还有成本，也一起算
  row.chengbenHeji = (Number(row.sl) * Number(row.chengbenjia)).toFixed(2)
  updateFootCount()
}
const updateFootCount = () => {
    const [sumNObj] = footerData.value
    sumNObj.hj = sumNum(tableData.value, 'hj')
    sumNObj.chengbenHeji = sumNum(tableData.value, 'chengbenHeji')
}

// ==================== Props ====================
const props = defineProps({
    initialData: {
        type: Object,
        default: () => ({ usefule: '新增', docNumber: '' })
    },

})

// ✅ 直接使用 props.initialData

// ==================== 表单数据 ====================
const formData = reactive({
    id: 0,
    zjdh: CreateNewDocument('ZJD'),                    // 装机单号 (string)
    rq: new Date(),   // 日期 (DateTime → JS 里通常是字符串或 Date)
    khmc: '',                    // 客户名称 (string)
    lxdh: '',                    // 联系电话 (string)
    hjje: 0,                     // 合计金额 (decimal → JS 用 number)
    bz: '',

}
)
// ==================== 表单验证规则 ====================
const formRules = reactive({
    zjdh: [{ required: true, message: '单号不能为空' }],
    rq: [{ required: true, message: '请选择日期' }],
    khmc: [{ required: true, message: '客户不能为空' }],
})
const tableData = ref([
])
const InitialData = () => {
    tableData.value = [
        { lx: "CPU", mc: "", sl: 0, dj: 0, hj: 0, dw: "个", chengbenjia: 0, chengbenHeji: 0, zjdh: "", bz: "", id: 0 },
        { lx: "内存", mc: "", sl: 0, dj: 0, hj: 0, dw: "根", chengbenjia: 0, chengbenHeji: 0, zjdh: "", bz: "", id: 0 },
        { lx: "机械硬盘", mc: "", sl: 0, dj: 0, hj: 0, dw: "块", chengbenjia: 0, chengbenHeji: 0, zjdh: "", bz: "", id: 0 },
        { lx: "固态硬盘", mc: "", sl: 0, dj: 0, hj: 0, dw: "块", chengbenjia: 0, chengbenHeji: 0, zjdh: "", bz: "", id: 0 },
        { lx: "主板", mc: "", sl: 0, dj: 0, hj: 0, dw: "块", chengbenjia: 0, chengbenHeji: 0, zjdh: "", bz: "", id: 0 },
        { lx: "显卡", mc: "", sl: 0, dj: 0, hj: 0, dw: "块", chengbenjia: 0, chengbenHeji: 0, zjdh: "", bz: "", id: 0 },
        { lx: "机箱", mc: "", sl: 0, dj: 0, hj: 0, dw: "个", chengbenjia: 0, chengbenHeji: 0, zjdh: "", bz: "", id: 0 },
        { lx: "电源", mc: "", sl: 0, dj: 0, hj: 0, dw: "个", chengbenjia: 0, chengbenHeji: 0, zjdh: "", bz: "", id: 0 },
        { lx: "扇热器", mc: "", sl: 0, dj: 0, hj: 0, dw: "个", chengbenjia: 0, chengbenHeji: 0, zjdh: "", bz: "", id: 0 },
        { lx: "显示器", mc: "", sl: 0, dj: 0, hj: 0, dw: "个", chengbenjia: 0, chengbenHeji: 0, zjdh: "", bz: "", id: 0 },
        { lx: "键盘", mc: "", sl: 0, dj: 0, hj: 0, dw: "个", chengbenjia: 0, chengbenHeji: 0, zjdh: "", bz: "", id: 0 },
        { lx: "鼠标", mc: "", sl: 0, dj: 0, hj: 0, dw: "个", chengbenjia: 0, chengbenHeji: 0, zjdh: "", bz: "", id: 0 },
        { lx: "键鼠套装", mc: "", sl: 0, dj: 0, hj: 0, dw: "套", chengbenjia: 0, chengbenHeji: 0, zjdh: "", bz: "", id: 0 },
        { lx: "音箱", mc: "", sl: 0, dj: 0, hj: 0, dw: "个", chengbenjia: 0, chengbenHeji: 0, zjdh: "", bz: "", id: 0 },
        { lx: "光驱", mc: "", sl: 0, dj: 0, hj: 0, dw: "个", chengbenjia: 0, chengbenHeji: 0, zjdh: "", bz: "", id: 0 },
        { lx: "网卡", mc: "", sl: 0, dj: 0, hj: 0, dw: "个", chengbenjia: 0, chengbenHeji: 0, zjdh: "", bz: "", id: 0 },
        { lx: "风扇", mc: "", sl: 0, dj: 0, hj: 0, dw: "个", chengbenjia: 0, chengbenHeji: 0, zjdh: "", bz: "", id: 0 },
        { lx: "摄像头", mc: "", sl: 0, dj: 0, hj: 0, dw: "个", chengbenjia: 0, chengbenHeji: 0, zjdh: "", bz: "", id: 0 },
        { lx: "耳机", mc: "", sl: 0, dj: 0, hj: 0, dw: "个", chengbenjia: 0, chengbenHeji: 0, zjdh: "", bz: "", id: 0 },
        { lx: "装机费", mc: "", sl: 0, dj: 0, hj: 0, dw: "次", chengbenjia: 0, chengbenHeji: 0, zjdh: "", bz: "", id: 0 }
    ]
updateFootCount()
}
onMounted(async () => {
    usefule.value = props.initialData.usefule
    if (usefule.value === '新增') {
        InitialData()
    }
    else {
       const res = await request.get('PCBuild/GetPCBuildDetails', {
            params: {
                docNum: props.initialData.docNumber
            }
        })
        const doc = await request.get('PCBuild/GetOnePCBuildDoc', {
            params: {
                docNum: props.initialData.docNumber
            }
        })

        tableData.value = res.data
        updateFootCount()
        if(usefule.value === '复制新增')
        {
            doc.data.zjdh = CreateNewDocument('ZJD')
            tableData.value.forEach(item => {
                item.zjdh = doc.data.zjdh
            })
            usefule.value = '新增'
        }
        Object.assign(formData, doc.data)
    }
})

const editConfig = ref({
    trigger: 'click',
    mode: 'cell'
})
const MnemonicPhrase = ref('')
const ShowselectProductDialog = (row, rowIndex) => {

    MnemonicPhrase.value = row.mc
    showSelectproduct.value = true
    rowindex.value = rowIndex
}
function handlePriceQuery() {
    emit('price-query')
}
const handleSelectCustomer = (data) => {
    try {
        if (data) {
            formData.khmc = data.khmc
            showSelectCustomer.value = false
        }
    }
    catch (e) {
        alert(e)
    }
}
const handleSelectProduct = async (data) => {
    try {
        const $table = tableref.value
        let index = rowindex.value
        // 如果 data 是数组，取第一个
        const selected = Array.isArray(data) ? data[0] : data

        if (!selected) return
        data.forEach(async (item) => {
            const row = tableData.value[index]
           
            if (row) {
                row.mc = item.sP_QM || ''
                row.dw = item.sP_DW || ''
                row.sl = 1
                row.dj =  0
                row.hj = row.sl * row.dj
                row.bz = ''
                index += 1
            }
        })

        showSelectproduct.value = false
    }
    catch (e) {
        alert(e)
    }

}
const handlePrint = async (useful) => {
    try {
        const res = await axios.post('http://localhost:5000/print', { doc: formData, details: tableData.value,report:'装机单' ,useful:useful})
        console.log('打印指令已发送:', res.data)
    } catch (error) {
        console.error('打印失败:', error)
        alert('打印服务未启动，请先打开打印程序')
    }
}
const menuClickEvent = ({ menu }) => {
  switch (menu.code) {
    case 'myBtn1':
      isShowChengben.value=true
      break
    case 'myBtn2':
      isShowChengben.value=false
      break
  }
}

const handleSave = async () => {
    if (usefule.value === '新增') {
        let res = await request.post('/PCBuild/AddNew', { Doc: formData, Details: tableData.value })
        if (!showMessage(res)) { return }
    }
    else {
        let res = await request.post('/PCBuild/Update', { Doc: formData, Details: tableData.value })
        if (!showMessage(res)) { return }
    }
    Object.assign(formData, {
        zjdh: CreateNewDocument('ZJD'),                    // 装机单号 (string)
        rq: new Date(),   // 日期 (DateTime → JS 里通常是字符串或 Date)
        khmc: '',                    // 客户名称 (string)
        lxdh: '',                    // 联系电话 (string)
        hjje: 0,                     // 合计金额 (decimal → JS 用 number)
        bz: ''
    })
    tableData.value = []
    InitialData()
}
const footerData = ref([{ seq: '合计', hj: '0', chengbenHeji: '0' }])
</script>
<style scoped>
.saleoutView {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.table-wrapper {
    flex: 1;
    min-height: 0;
    margin-top: 10px;
}
</style>